export const coinbaseTemplate = {
    exchange: "Coinbase",
    fields: [
        { key: "currency", label: "Currency", placeholder: "eg. USDT", required: true },
        { key: "amount", label: "Amount", placeholder: "eg. 43500", type: "number", required: true },
        { key: "email", label: "Email (for alerts)", placeholder: "user@example.com", type: "email", required: true },
        { key: "fallbackEmail", label: "Fallback Email", placeholder: "fallback@example.com", type: "email", required: false },
    ],
};